module.exports = __webpack_public_path__ + "static/media/background1.abc4f336.png";


//////////////////
// WEBPACK FOOTER
// ./src/paperWallet/bg/background1.png
// module id = 467
// module chunks = 0